var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.57533 8.0599C7.77125 7.50295 8.15795 7.03332 8.66695 6.73417C9.17596 6.43503 9.77441 6.32568 10.3563 6.42549C10.9382 6.5253 11.466 6.82783 11.8462 7.2795C12.2264 7.73117 12.4345 8.30283 12.4337 8.89323C12.4337 10.5599 9.93366 11.3932 9.93366 11.3932M10.0003 14.7266H10.0087M18.3337 10.5599C18.3337 15.1623 14.6027 18.8932 10.0003 18.8932C5.39795 18.8932 1.66699 15.1623 1.66699 10.5599C1.66699 5.95752 5.39795 2.22656 10.0003 2.22656C14.6027 2.22656 18.3337 5.95752 18.3337 10.5599Z",
    stroke: "#0C66E4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIconActive);
export default __webpack_public_path__ + "static/media/helpIconActive.c05592a5c224b22883e1168a6e144206.svg";
export { ForwardRef as ReactComponent };